import { Box, Typography } from "@mui/material";
import { CircleAlert, CircleHelp, TriangleAlert } from "lucide-react";

import { useTheme } from "@mui/material/styles";
import { BADGE_TONES } from "../theme/badgeTones";
import { colors } from "../theme/theme";

const VARIANTS = {
  danger: { icon: TriangleAlert, color: colors.error.main },
  warning: { icon: CircleAlert, color: BADGE_TONES.pending.color },
  info: { icon: CircleHelp, color: BADGE_TONES.info.color },
};

/**
 * Aviso con fondo tintado, icono y texto oscuro.
 * `danger` (rojo, triángulo) · `warning` (naranja, !) · `info` (azul, ?). Mismos iconos que ConfirmModal.
 */
export const AlertNote = ({ children, variant = "danger", icon, action, sx = {} }) => {
  const theme = useTheme();
  const config = VARIANTS[variant] || VARIANTS.danger;
  const color = config.color;
  const Icon = icon || config.icon;
  return (
    <Box
      role={variant === "info" ? "note" : "alert"}
      sx={{
        backgroundColor: `${color}0D`,
        border: `1px solid ${color}33`,
        padding: 2,
        borderRadius: "8px",
        display: "flex",
        alignItems: "flex-start",
        gap: 1.5,
        ...sx,
      }}
    >
      <Icon size={18} color={color} style={{ flexShrink: 0, marginTop: 2 }} />
      <Typography
        variant="body2"
        component="div"
        sx={{ flex: 1, minWidth: 0, fontSize: "0.875rem", color: theme.palette.text.primary, wordBreak: "break-word" }}
      >
        {children}
      </Typography>
      {action && <Box sx={{ flexShrink: 0, alignSelf: "center" }}>{action}</Box>}
    </Box>
  );
};
